import React, { useState } from 'react';
import { Box, Plus, Search } from 'lucide-react';
import { useAppStore } from '../store';
import { TEMPLATES, MATERIALS } from '../engineeringRules';

export default function Parts() {
  const jobs = useAppStore(s => s.jobs);
  const [search, setSearch] = useState('');
  const partsJobs = jobs.filter(j => j.part && j.part_no);

  const filtered = partsJobs.filter(j =>
    (j.part_no || '').toLowerCase().includes(search.toLowerCase()) ||
    (j.customer || '').toLowerCase().includes(search.toLowerCase()) ||
    (j.description || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="fade-in">
      <div className="section-header">
        <h1>Part Library</h1>
        <span className="badge badge-blue">{partsJobs.length} parts</span>
      </div>

      <div style={{ marginBottom: 20, position: 'relative' }}>
        <Search size={13} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--forge-text3)' }} />
        <input className="input" style={{ paddingLeft: 32 }} placeholder="Search parts…"
          value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      {filtered.length === 0 ? (
        <div className="empty-state"><Box size={32} /><p style={{ marginTop: 12 }}>No parts yet. Create a job to add parts.</p></div>
      ) : (
        <div className="grid-3">
          {filtered.map(job => {
            const part = job.part!;
            const mat = MATERIALS[part.material_id ?? 'SAE1010'];
            return (
              <div key={job.id} className="card card-hover">
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                  <span className="tag">{part.part_type}</span>
                  <span className="badge badge-gray">{part.material_id}</span>
                </div>
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>{job.part_no}</div>
                <div style={{ fontSize: 11, color: 'var(--forge-text2)', marginBottom: 8 }}>{job.description}</div>
                <div style={{ fontSize: 11, color: 'var(--forge-text3)' }}>
                  M{part.nominal_diameter_mm}×{part.thread_pitch_mm} · {part.total_length_mm}mm
                </div>
                <div style={{ fontSize: 11, color: 'var(--forge-text3)' }}>{job.customer}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
